export default "/images/brand.png?34d1cebd2c56a263992a848b83dffccd";